import { atom } from "recoil";

export const notificationAtom = atom({
  key: "notificationState",
  default: { data: [] },
});
